const generateCssClassName = (
  classNameArr: Array<string> | null,
  shouldReturnClassName: boolean,
): string => {
  if (classNameArr && shouldReturnClassName) {
    return classNameArr.join(' ').toLowerCase();
  }
  return '';
};

export default generateCssClassName;
